import {DLSelect, intlShape, utils} from '@wallaby-ui/core';
import {map} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl';

import styles from './SelectHierarchyBox.less';
import {HierarchyTypes} from 'src/js/model/hierarchy';

const I18N = defineMessages({
  TITLE: {
    id: 'hierarchy.select.title',
    defaultMessage: 'Choose hierarchy',
    description: 'title text for select hierarchy input',
  },
  LABEL: {
    id: 'hierarchy.select.label',
    defaultMessage: 'Hierarchy',
    description: 'label for select hierarchy input',
  },
  PLACEHOLDER: {
    id: 'hierarchy.select.placeholder',
    defaultMessage: 'Choose hierarchy ...',
    description: 'placeholder text for select hierarchy input',
  },
});

class SelectHierarchyBox extends React.PureComponent {
  render() {
    const {changeHierarchy, intl, hierarchyId, hierarchyTypes} = this.props;
    return (
      <div className={styles.dlSelectHierarchyBox}>
        <span
          className={styles.dlSelectHierarchyBoxLabel}
          title={utils.TranslateUtils.translate(I18N.TITLE, intl)}
        >
          <span>
            <FormattedMessage {...I18N.LABEL} />
            {':'}
          </span>
        </span>
        <DLSelect
          className={styles.dlSelectHierarchyBoxInput}
          name={'selectHierarchy'}
          id={'selectHierarchy'}
          selectedValue={hierarchyId}
          options={map(hierarchyTypes.getItems(), (item) =>
            item.getOptionsProjection()
          )}
          placeholderText={I18N.PLACEHOLDER.id}
          onChange={changeHierarchy}
        />
      </div>
    );
  }
}

SelectHierarchyBox.displayName = 'SelectHierarchyBox';

SelectHierarchyBox.propTypes = {
  changeHierarchy: PropTypes.func.isRequired,
  hierarchyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hierarchyTypes: PropTypes.instanceOf(HierarchyTypes).isRequired,
  intl: intlShape.isRequired,
};

SelectHierarchyBox.defaultProps = {
  hierarchyId: undefined,
};

export default injectIntl(SelectHierarchyBox);
